import { render, staticRenderFns } from "./InternalTransferModal.vue?vue&type=template&id=4f5ea66d"
import script from "./InternalTransferModal.vue?vue&type=script&lang=js"
export * from "./InternalTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports